import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { selector } from "../../../api";
import { invoiceCRUD } from "../../../actions/invoice";
import { TableShared } from "../../../shared";
import { char } from "../../../utils";
import { Button, Dropdown, Space, notification } from "antd";
import { MoreOutlined, SyncOutlined } from "@ant-design/icons";
import { AccountTransactionData } from "./transaction";
import CloseIcon from "@rsuite/icons/Close";
import { Input, InputGroup, SelectPicker } from "rsuite";

const items = [
  {
    label: "Transaction",
    key: "transaction",
    icon: <SyncOutlined />,
  },
];

export const AddmissionAccount = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataId, setDataId] = useState(null);
  const [dataName, setDataName] = useState(null);
  const [dataReg, setDataReg] = useState(null);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [searchType, setSearchType] = useState(null);
  const [name, setName] = useState("");
  const [indexNumber, setIndexNumber] = useState("");
  const [searchIndex, setSearchIndex] = useState(0);

  const [api, contextHolder] = notification.useNotification();

  const user = selector.User();

  useEffect(() => {
    if(searchType){
      setLoading(true);
      setTimeout(() => {
        invoiceCRUD
          .loadStudentAdmissionAccountByFilter(postsPerPage, nextPage, name, indexNumber, "-id")
          .then((resp) => {
            setData(resp.data.results);
            setCount(resp.data.count);
          })
          .catch((error) => {
            api.error({
              message: error.message,
              description:
                "Oops! It looks like you're not connected to the network. Please check your network connectivity and try again",
              placement: "topRight",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    } else {
      setLoading(true);
      setTimeout(() => {
        invoiceCRUD
          .loadStudentAdmissionAccount(postsPerPage, nextPage, value, "-id")
          .then((resp) => {
            setData(resp.data.results);
            setCount(resp.data.count);
          })
          .catch((error) => {
            api.error({
              message: error.message,
              description:
                "Oops! It looks like you're not connected to the network. Please check your network connectivity and try again",
              placement: "topRight",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [page, postsPerPage, value, index, nextPage, searchIndex]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 150,
    },
    {
      key: "account_code",
      title: "Account Code",
      dataIndex: "account_code",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "name",
      title: "Full Name",
      dataIndex: "name",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 150,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => (
        <Dropdown
          menu={{
            items,
            onClick: (event) => {
              switch (event.key) {
                case "transaction":
                  setOpen(true);
                  setDataId(record.id);
                  setDataName(record.payerName);
                  setDataReg(record.dataReg);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
          trigger={["click"]}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    payerName: dt.name,
    dataReg: dt.customer_account[0].account_code,
    sn: i + 1,
    account_code: dt.customer_account
      ? char.toUpperCase(dt.customer_account[0].account_code)
      : "N/A",
    name: dt.name ? char.toTitleCase(dt.name) : "N/A",
    status: dt.is_active ? (
      <span class="badge badge-soft-success badge-border">
        {char.toTitleCase("active")}
      </span>
    ) : (
      <span class="badge badge-soft-danger badge-border">
        {char.toTitleCase("inactive")}
      </span>
    ),
  }));

  const search = (
    <>
      <div className="col-md-3 col-sm-12">
        <SelectPicker
          size="lg"
          style={{
            width: "100%",
          }}
          placeholder="Search by ...."
          optionFilterProp="children"
          onChange={(e) => {
            setSearchType(e);
            setName("");
            setIndexNumber("");
          }}
          cleanable
          onClean={() => {
            setSearchType(null);
            setName("");
            setIndexNumber("");
            setSearchIndex(searchIndex + 1);
          }}
          data={[
            {
              label: "Student Name",
              value: "name",
            },
            {
              label: "Index Number",
              value: "indexNumber",
            },
          ]}
        />
      </div>
      {searchType === "name" && (
        <div className="col-md-3 col-sm-12">
          <InputGroup inside style={{ width: 300 }}>
            <Input
              placeholder="Search by student name"
              size="lg"
              value={name}
              onChange={(e) => setName(char.toLowerCase(e))}
            />
            {name && (
              <InputGroup.Button
                size="lg"
                onClick={() => {
                  setName("");
                  setSearchIndex(searchIndex + 1);
                }}
              >
                <CloseIcon />
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )}
      {searchType === "indexNumber" && (
        <div className="col-md-3 col-sm-12">
          <InputGroup inside style={{ width: 300 }}>
            <Input
              placeholder="Search by registration number"
              size="lg"
              value={indexNumber}
              onChange={(e) => setIndexNumber(char.toLowerCase(e))}
            />
            {indexNumber && (
              <InputGroup.Button
                size="lg"
                onClick={() => {
                  setIndexNumber("");
                  setSearchIndex(searchIndex + 1);
                }}
              >
                <CloseIcon />
              </InputGroup.Button>
            )}
          </InputGroup>
        </div>
      )}
      {searchType && (
        <div className="col-md-2 col-sm-12">
          <button
            className="btn btn-soft-info"
            onClick={() => {
              setSearchIndex(searchIndex + 1);
            }}
          >
            <span className="bi bi-search"></span> &nbsp; Search
          </button>
        </div>
      )}
      <div
        className={
          searchType
            ? "col-md-4 col-sm-12 d-flex flex-row-reverse"
            : "col-md-9 col-sm-12 d-flex flex-row-reverse"
        }
      >
        {null}
      </div>
    </>
  );

  return (
    <>
      {contextHolder}
      <AccountTransactionData
        open={open}
        setOpen={setOpen}
        payerId={dataId}
        name={dataName}
        reg={dataReg}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">
              Student Addmission Account
            </p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          setOpen={setOpen}
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={null}
          link={"#"}
          showButton={true}
          search={search}
          showSearch={true}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
